import { topicsData } from '@/mocks/home';

const topicStyles = [
  'bg-accent-500/10 text-accent-400 border-accent-500/20',
  'bg-primary-500/10 text-primary-400 border-primary-500/20',
  'bg-secondary-500/10 text-secondary-400 border-secondary-500/20',
  'bg-accent-500/10 text-accent-400 border-accent-500/20',
  'bg-primary-500/10 text-primary-400 border-primary-500/20',
  'bg-secondary-500/10 text-secondary-400 border-secondary-500/20',
  'bg-accent-500/10 text-accent-400 border-accent-500/20',
  'bg-primary-500/10 text-primary-400 border-primary-500/20',
  'bg-secondary-500/10 text-secondary-400 border-secondary-500/20',
  'bg-accent-500/10 text-accent-400 border-accent-500/20',
  'bg-primary-500/10 text-primary-400 border-primary-500/20',
];

export default function SectionTopics() {
  return (
    <section
      id="topics"
      className="py-16 md:py-20 bg-background-50"
    >
      <div className="max-w-[1920px] mx-auto px-4 md:px-6 lg:px-10">
        <div className="text-center mb-8 md:mb-10">
          <span className="inline-block text-xs font-medium text-accent-400 bg-accent-500/10 px-3 py-1 rounded-full mb-3">
            热议话题
          </span>
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-50">
            热门话题
          </h2>
          <p className="text-sm text-foreground-400 mt-2">大家都在讨论的影视热点</p>
        </div>

        <div className="flex flex-wrap justify-center gap-2.5 md:gap-3 max-w-4xl mx-auto">
          {topicsData.map((topic, idx) => (
            <div
              key={topic.name}
              className={`inline-flex items-center gap-2 px-4 py-2.5 rounded-full border cursor-pointer hover:scale-105 transition-transform text-sm ${topicStyles[idx % topicStyles.length]}`}
            >
              <span className="font-medium whitespace-nowrap">{topic.name}</span>
              <span className="text-[11px] opacity-70 whitespace-nowrap">{topic.heat}</span>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}